// removed by extract-text-webpack-plugin
module.exports = {"box":"dh-dh-plast-quiz-box","appear-in":"dh-dh-plast-quiz-appear-in","box--appear-late":"dh-dh-plast-quiz-box--appear-late"};


//////////////////
// WEBPACK FOOTER
// ./src/v1/components/Foreground/common/Box.css
// module id = 49
// module chunks = 0